/**
 * Scratch Card Configuration System
 * 
 * This file defines the structure and default configurations for all scratch card games.
 * It supports both pre-created games and user-created games.
 */

// Standard pre-created games
export const STANDARD_CARDS = [
  { 
    id: 'quick_cash', 
    name: 'QUICK CASH', 
    description: 'Win up to 50,000 JINU', 
    cost: 50,
    maxWin: 50000,
    bgColor: "#000000",
    textColor: "yellow.300",
    gridSize: { rows: 3, columns: 3 },
    prizes: ['5', '50', '500', '1K', '5K', '50K'],
    winningSymbols: 3,
    creatorFee: 0, // No creator fee for standard games
    creatorAddress: null,
    isOfficial: true
  },
  { 
    id: 'cash_king', 
    name: 'CASH KING', 
    description: 'Win up to 100,000 JINU', 
    cost: 200,
    maxWin: 100000,
    bgColor: "#1a4d1a", // Green
    textColor: "yellow.300",
    gridSize: { rows: 3, columns: 3 },
    prizes: ['100', '1K', '5K', '10K', '50K', '100K'],
    winningSymbols: 3,
    creatorFee: 0,
    creatorAddress: null,
    isOfficial: true
  },
  { 
    id: 'jackpot_millions', 
    name: 'JACKPOT MILLIONS', 
    description: 'Win up to 250,000 JINU', 
    cost: 500,
    maxWin: 250000,
    bgColor: "#8B008B", // Purple
    textColor: "yellow.300",
    gridSize: { rows: 3, columns: 3 },
    prizes: ['1K', '5K', '10K', '50K', '100K', '250K'],
    winningSymbols: 3,
    creatorFee: 0,
    creatorAddress: null,
    isOfficial: true
  },
  { 
    id: 'quick_cash_premium', 
    name: 'QUICK CASH PREMIUM', 
    description: 'Win up to 75,000 JINU', 
    cost: 100,
    maxWin: 75000,
    bgColor: "#8B4513", // Brown
    textColor: "yellow.300",
    gridSize: { rows: 3, columns: 3 },
    prizes: ['200', '1K', '5K', '10K', '25K', '75K'],
    winningSymbols: 3,
    creatorFee: 0,
    creatorAddress: null,
    isOfficial: true
  }
];

// User-created games (initially empty, will be populated from backend)
export const USER_CREATED_CARDS = [];

// Get all available cards (both standard and user-created)
export const getAllCards = () => {
  return [...STANDARD_CARDS, ...USER_CREATED_CARDS];
};

// Get a card by ID
export const getCardById = (cardId) => {
  const allCards = getAllCards();
  return allCards.find(card => card.id === cardId) || allCards[0];
};

// Template for creating new cards
export const CARD_TEMPLATE = {
  name: 'NEW CARD',
  description: 'Win up to 100,000 JINU',
  cost: 100,
  maxWin: 100000,
  bgColor: "#4B0082", // Default indigo
  textColor: "yellow.300",
  gridSize: { rows: 3, columns: 3 },
  prizes: ['100', '1K', '5K', '10K', '50K', '100K'],
  winningSymbols: 3,
  creatorFee: 0.20, // 20% creator fee
  isOfficial: false
};

// Card creation validation
export const validateCardConfig = (config) => {
  const errors = [];
  
  if (!config.name || config.name.length < 3) {
    errors.push("Card name must be at least 3 characters");
  }
  
  if (config.cost < 10 || config.cost > 1000) {
    errors.push("Card cost must be between 10 and 1000 JINU");
  }
  
  if (config.maxWin < config.cost * 10) {
    errors.push("Maximum win must be at least 10x the card cost");
  }
  
  if (config.prizes.length < 3) {
    errors.push("Card must have at least 3 prize tiers");
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};
